import { render, staticRenderFns } from "./logoinfo.vue?vue&type=template&id=f76a14d8&scoped=true&"
import script from "./logoinfo.vue?vue&type=script&lang=js&"
export * from "./logoinfo.vue?vue&type=script&lang=js&"
import style0 from "./logoinfo.vue?vue&type=style&index=0&id=f76a14d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f76a14d8",
  null
  
)

export default component.exports